import { MISSING_PARAMS_ERROR } from './constants';

const LOCATION_ALERT_PATH_REGEXP = /^\/locationAlert(\/.*)?$/;

export const isLocationAlertPublicPathname = (pathname: string): boolean =>
  LOCATION_ALERT_PATH_REGEXP.test(pathname);

export const getLocationAlertErrorMessageId = (error: Error): string =>
  error.message === MISSING_PARAMS_ERROR
    ? 'location.alert.error.missing.params'
    : 'location.alert.error.visit';
